module.exports = __webpack_public_path__ + "img/logo800x325.78ed38b6.jpeg";